'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppAuthData$PharmacyUser$Raw(token) {
  this.Lapp_data_AppAuthData$PharmacyUser$Raw__f_token = null;
  this.Lapp_data_AppAuthData$PharmacyUser$Raw__f_token = token;
}
export { $c_Lapp_data_AppAuthData$PharmacyUser$Raw as $c_Lapp_data_AppAuthData$PharmacyUser$Raw };
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype.constructor = $c_Lapp_data_AppAuthData$PharmacyUser$Raw;
/** @constructor */
function $h_Lapp_data_AppAuthData$PharmacyUser$Raw() {
}
export { $h_Lapp_data_AppAuthData$PharmacyUser$Raw as $h_Lapp_data_AppAuthData$PharmacyUser$Raw };
$h_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype = $c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype;
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1842487681, true);
});
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppAuthData$PharmacyUser$Raw)) {
    var x = this.Lapp_data_AppAuthData$PharmacyUser$Raw__f_token;
    var x$2 = x$0.Lapp_data_AppAuthData$PharmacyUser$Raw__f_token;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype.productPrefix__T = (function() {
  return "Raw";
});
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_AppAuthData$PharmacyUser$Raw__f_token;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "token";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_AppAuthData$PharmacyUser$Raw.prototype.token__Lframework_data_AuthToken = (function() {
  return this.Lapp_data_AppAuthData$PharmacyUser$Raw__f_token;
});
function $isArrayOf_Lapp_data_AppAuthData$PharmacyUser$Raw(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppAuthData$PharmacyUser$Raw)));
}
export { $isArrayOf_Lapp_data_AppAuthData$PharmacyUser$Raw as $isArrayOf_Lapp_data_AppAuthData$PharmacyUser$Raw };
var $d_Lapp_data_AppAuthData$PharmacyUser$Raw = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppAuthData$PharmacyUser$Raw, "app.data.AppAuthData$PharmacyUser$Raw", ({
  Lapp_data_AppAuthData$PharmacyUser$Raw: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  Lapp_data_AppAuthData: 1,
  Lapp_data_AppAuthData$PharmacyUser: 1,
  Lapp_data_AppAuthData$Base: 1
}));
export { $d_Lapp_data_AppAuthData$PharmacyUser$Raw as $d_Lapp_data_AppAuthData$PharmacyUser$Raw };
//# sourceMappingURL=app.data.-App-Auth-Data$-Pharmacy-User$-Raw.js.map
